export enum Authority {
  ADMIN = { code: 0, description: 'USER.ADMIN', key: 'ADMIN' } as any,
  MANAGER = { code: 1, description: 'USER.MANAGER', key: 'MANAGER' } as any,
  ATTENDANT = { code: 2, description: 'USER.ATTENDANT', key: 'ATTENDANT' } as any,
  KITCHEN = { code: 3, description: 'USER.KITCHEN', key: 'KITCHEN' } as any,
  // MASTER 		= { code: 5, description: 'USER.MASTER', key: 'MASTER' } as any,
  DELIVERYMAN = { code: 6, description: 'USER.DELIVERYMAN', key: 'DELIVERYMAN' } as any,
  WAITER = { code: 7, description: 'USER.WAITER', key: 'WAITER' } as any,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/authority.enum.ts